const REPORT_STORAGE_PREFIX = 'thetavern.supportReport.';
const MAX_REPORT_AGE_MS = 30 * 60 * 1000;
const MAX_TEXT_LENGTH = 1800;

const scrubText = (value, maxLength = MAX_TEXT_LENGTH) => {
  if (value === null || value === undefined) return '';

  return String(value)
    .replace(/Bearer\s+[A-Za-z0-9._~+/=-]+/gi, 'Bearer [redacted]')
    .replace(/token=([^&\s]+)/gi, 'token=[redacted]')
    .replace(/password=([^&\s]+)/gi, 'password=[redacted]')
    .replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}\b/gi, '[email]')
    .slice(0, maxLength)
    .trim();
};

const supportReportKey = (id) => `${REPORT_STORAGE_PREFIX}${id}`;

export const getPreviousRoute = () => {
  try {
    return window.sessionStorage.getItem('thetavern.previousRoute') || '';
  } catch {
    return '';
  }
};

export const rememberRoute = (pathname, search = '') => {
  try {
    const nextRoute = `${pathname}${search || ''}`;
    const currentRoute = window.sessionStorage.getItem('thetavern.currentRoute');

    if (currentRoute && currentRoute !== nextRoute) {
      window.sessionStorage.setItem('thetavern.previousRoute', currentRoute);
    }

    window.sessionStorage.setItem('thetavern.currentRoute', nextRoute);
  } catch {
    // Non-critical: support prefill still works without route history.
  }
};

export const saveSupportReportDraft = (context = {}) => {
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const draft = {
    createdAt: Date.now(),
    category: context.category || 'bug',
    pageName: scrubText(context.pageName || document.title || 'The Tavern', 120),
    page: scrubText(context.page || window.location.pathname, 300),
    previousRoute: scrubText(context.previousRoute || getPreviousRoute(), 300),
    endpoint: scrubText(context.endpoint, 300),
    method: scrubText(context.method, 12),
    status: scrubText(context.status, 80),
    requestId: scrubText(context.requestId, 120),
    errorType: scrubText(context.errorType, 160),
    errorMessage: scrubText(context.errorMessage, 600),
    stack: scrubText(context.stack, 1600),
    timestamp: new Date().toISOString(),
  };

  try {
    window.sessionStorage.setItem(supportReportKey(id), JSON.stringify(draft));
  } catch {
    return null;
  }

  return id;
};

export const readSupportReportDraft = (id) => {
  if (!id) return null;

  try {
    const raw = window.sessionStorage.getItem(supportReportKey(id));
    if (!raw) return null;

    const draft = JSON.parse(raw);
    if (!draft.createdAt || Date.now() - draft.createdAt > MAX_REPORT_AGE_MS) {
      window.sessionStorage.removeItem(supportReportKey(id));
      return null;
    }

    return draft;
  } catch {
    return null;
  }
};

export const clearSupportReportDraft = (id) => {
  try {
    window.sessionStorage.removeItem(supportReportKey(id));
  } catch {}
};

export const supportReportPath = (draftId) =>
  draftId ? `/support?report=${encodeURIComponent(draftId)}` : '/support';

export const supportContextFromApiError = (error, context = {}) => {
  const report = error?.tavernReport || {};

  return {
    category: 'bug',
    errorType: 'API error',
    page: window.location.pathname,
    endpoint: report.endpoint,
    method: report.method,
    status: report.status,
    requestId: report.requestId,
    errorMessage: report.errorMessage || error?.message,
    ...context,
  };
};
